const Cities = [
    {
        id: 'gdingen',
        svgIndex: 0,
    },
    {
        id: 'kattowitz',
        svgIndex: 7,
    },
    {
        id: 'st-annaberg',
        svgIndex: 6,
    },
    {
        id: 'neu-bentschen',
        svgIndex: 4,
    },
    {
        id: 'posen',
        svgIndex: 5,
    },
    {
        id: 'frankfurt-oder',
        svgIndex: 1,
    },
    {
        id: 'meseritz',
        svgIndex: 2,
    },
    {
        id: 'schneidemuehl',
        svgIndex: 3,
    },
];

export default class Map {
    constructor(el, options) {
        this.el = el;
        this.options = options;

        this.detailActive = false;

        this.bindUi();
        this.bindEventListener();
    }


    bindUi() {
        this.ui = {
            map: this.el.querySelector('.map-wrapper svg'),
            mapCitiesLandscape: this.el.querySelectorAll('.map-wrapper .map-landscape svg #interaktive_x5F_orte g'),
            mapCitiesPortrait: this.el.querySelectorAll('.map-wrapper .map-portrait svg #interaktive_x5F_orte g'),
            citiesWrapper: this.el.querySelector('.cities'),
            cities: this.el.querySelectorAll('.cities-content .city'),
        };
    }

    bindEventListener() {
        this.ui.citiesWrapper.querySelector('.close')
            .addEventListener('click', () => this.hideCityDetail());

        this.ui.mapCitiesLandscape.forEach((point, index) => point.addEventListener('click', () => {
            const location = Cities.find(city => city.svgIndex === index);
            this.showCityDetail(location);
        }));

        this.ui.mapCitiesPortrait.forEach((point, index) => point.addEventListener('click', () => {
            const location = Cities.find(city => city.svgIndex === index);
            this.showCityDetail(location);
        }));
    }

    showCityDetail(location) {
        this.ui.cities.forEach(el => el.classList.remove('show'));

        if (window.innerWidth <= 512 ) {
            document.body.classList.add('no-scroll');
        }

        this.ui.citiesWrapper.classList.add('show');

        const cityEl = this.ui.citiesWrapper.querySelector(`.city[data-id=${location.id}]`);
        cityEl.classList.add('show');

        this.detailActive = true;
    }

    hideCityDetail() {
        if (this.detailActive) {
            this.ui.cities.forEach(el => el.classList.remove('show'));
            this.ui.citiesWrapper.classList.remove('show');
            document.body.classList.remove('no-scroll');
            this.detailActive = false;
        }
    }
}



// WEBPACK FOOTER //
// ./source/_assets/js/components/Map.js